<div class="gestion-container">
    <header class="text-center mt-4">
      <h1 class="mb-2 title-section text-center">Catalogo puestos homologados</h1>
      <h3>Seleccione el archivo Excel con los datos a cargar</h3>
    </header>
  
    <div class="row col-12 mt-2" file-drop>
      <div class="card col-4 offset-md-4">
        <div class="card-body">
          <div class="p-2 button-fluid">
            <button type="button" class="btn form-button-gold border-transparent ml-3 mt-2" (click)="downloadFile()">
              Descargar plantilla
            </button>
          </div>

          <!-- DROPZONE -->
          <div class="col-md-12 mt-4 mb-3" (dragover)="onDragOver($event)" (drop)="dropAttachFiles($event)">
            <div class="upload-container align-items-center" style="margin-top: 5px;">
              <div class="align-items-center">
                <div class="mat-img mb-2">
                  <div class="mt-2">
                    <mat-icon class="icon-c-folder mat-icon" svgIcon="upload-icon" aria-hidden="false"></mat-icon>
                  </div>
                  <div class="mt-3">
                    <label>Arrastre o seleccione un archivo</label>
                  </div>
                  <label class="btn button-blue btn-upload" for="upload"><i class="fa fa-plus"></i>Seleccionar Archivo</label>
                  <input #inputFile type="file" id="upload" style="display:none" accept=".xlsx, .XLSX" (change)="dropAttachFiles($event);"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="p-3 pt-1 p-relative"></footer>
  </div>
     